import React from 'react';
import Caurosel from './Caurosel';
import '../stylesheets/professionals.scss';

import users from '../../data/users/users-profile.json';



class Professionals extends React.Component { 
  render() {
    let professionals = users.talent.professional;
    return (
      <div className='professionals-container'>
        <div className='professionals-content-container'>
          <div className='professionals-content'>
            <Caurosel
              data={professionals}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Professionals;